// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetInfrastructureRequest,
  TGetInfrastructureModel,
  IMappers,
  TGetInfrastructureResponse,
  IGetInfrastructureResponse,
  IGetInfrastructureResponseError,
} from './types';

export const defaultConfig: TGetInfrastructureModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'newbuilding-card',
  pathApi: '/v1/get-infrastructure/',
} as TGetInfrastructureModel;

export function createGetInfrastructureModel(parameters: IGetInfrastructureRequest): TGetInfrastructureModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetInfrastructureOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetInfrastructureRequest;
}

export async function fetchGetInfrastructure<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetInfrastructureOptions<TResponse200, TResponse400>): Promise<
  TGetInfrastructureResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetInfrastructureModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetInfrastructureResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetInfrastructureResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetInfrastructureResponse;
}
